import { createAction } from 'redux-starter-kit';

export const SET_IMAGES = 'images/SET';
export const ADD_IMAGE = 'images/ADD';
export const SET_IMAGES_LOADING = 'images/LOADING';

const setImages = createAction(SET_IMAGES);
const addImage = createAction(ADD_IMAGE);
const setImagesLoading = createAction(SET_IMAGES_LOADING);

export const reportActions = {
  setImages,
  addImage,
  setImagesLoading
};
